import { render, staticRenderFns } from "./EditorWysiwyg.vue?vue&type=template&id=242f5f50&scoped=true"
import script from "./EditorWysiwyg.vue?vue&type=script&lang=js"
export * from "./EditorWysiwyg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f5f50",
  null
  
)

export default component.exports